const showStuff = (show ,hide) => {
  show.forEach(element => {
    const target =document.getElementsByClassName(element)[0]
    console.log('target',target[0])
    if(element.includes('btn')){
      target.classList.remove('inactive')
      target.classList.add('active')
    } else {
      target.classList.remove('hide')
    }
  });
  hide.forEach(element => {
    const target =document.getElementsByClassName(element)[0]
    if(element.includes('btn')){
      target.classList.remove('active')
      target.classList.add('inactive')
    } else {
      target.classList.add('hide')
    }
  });
}
// 根據 URL hash 切換到對應的 tab
function handleHashChange() {
  var hash = decodeURIComponent(window.location.hash.replace('#', ''));
  if (hash) {
    var tabs = document.querySelectorAll('#navTab .nav-link');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].textContent.trim() === hash) {
        tabs[i].click();
        break;
      }
    }
  }
}

// event listener
window.addEventListener('load', () => {
  setTimeout(()=>{
    document.querySelector('.preload-bg').classList.add('ra-hidden')
    setTimeout(()=>{
      document.querySelector('.preload-bg').parentNode.removeChild(document.querySelector('.preload-bg'));
    },  500)
    document.querySelector('body').classList.remove('ra-loaded');
    document.getElementById('ra-year').innerHTML = new Date().getFullYear();
    setTimeout(()=>{
      document.querySelector('body').classList.remove('ra-preload');
    }, 1500)

    // 頁面載入時處理 hash
    handleHashChange();
  }, 800)
})

// 監聽 hash 變化
window.addEventListener('hashchange', handleHashChange)
window.addEventListener('scroll', () => {
  // console.log('scroll')
  let scrollTop = window.pageYOffset;
  let navElement = document.querySelector('nav');
  let isBgColor = navElement.classList.contains('ra-nav-bg')
  if(scrollTop > 10 && !isBgColor){
    navElement.classList.add('ra-nav-bg');
  }else if(scrollTop == 0 && isBgColor){
    navElement.classList.remove('ra-nav-bg');
  }
})
document.getElementById('navBtn').addEventListener('click', (e) => {
  e.stopPropagation();
  const menu = document.getElementById('navMenu');
  if(menu.classList.contains('show')){
    menu.classList.remove('show')
  }else{
    menu.classList.add('show')
  }
})
document.querySelector('#navMenu ul').addEventListener('click', (e) => {
  const menu = document.getElementById('navMenu');
  if(window.innerWidth <= 767.98 && menu.classList.contains('show')){
    document.getElementById('navMenu').classList.remove('show')
  }
})

// Close mobile menu when clicking outside
document.addEventListener('click', (e) => {
  const menu = document.getElementById('navMenu');
  const navBtn = document.getElementById('navBtn');
  const navbar = document.querySelector('nav.navbar');

  if (window.innerWidth <= 767.98 && menu.classList.contains('show')) {
    // Check if click is outside navbar
    if (!navbar.contains(e.target)) {
      menu.classList.remove('show');
    }
  }
})

// Tab 切換功能
document.querySelectorAll('#navTab .nav-link').forEach(tab => {
  tab.addEventListener('click', function(e) {
    e.preventDefault();

    // 移除所有 tab 的 active
    document.querySelectorAll('#navTab .nav-link').forEach(t => t.classList.remove('active'));

    // 加入 active 到點擊的 tab
    this.classList.add('active');

    // 隱藏所有 tab-pane
    document.querySelectorAll('.tab-pane').forEach(pane => {
      pane.classList.remove('show', 'active');
    });

    // 顯示目標 tab-pane
    const targetId = this.getAttribute('href');
    const targetPane = document.querySelector(targetId);
    if (targetPane) {
      targetPane.classList.add('show', 'active');
    }

    // 更新 URL（使用導覽列名稱）
    var tabName = this.textContent.trim();
    window.location.hash = tabName;

    // 如果是員工福利，重置為列表頁
    if (targetId === '#employee-benefits') {
      showBenefitsList();
    }
  });
})

// 員工福利頁面切換功能
function showBenefitDetail(type) {
  const benefitsList = document.getElementById('benefits-list');
  const benefitsHeader = document.querySelector('.benefits-header');
  const detailPage = document.getElementById('benefit-detail-' + type);
  if (benefitsList && detailPage) {
    benefitsList.classList.add('hide');
    if (benefitsHeader) benefitsHeader.classList.add('hide');
    document.querySelectorAll('.benefit-detail').forEach(detail => {
      detail.classList.add('hide');
    });
    detailPage.classList.remove('hide');
  }
}

function showBenefitsList() {
  const benefitsList = document.getElementById('benefits-list');
  const benefitsHeader = document.querySelector('.benefits-header');
  if (benefitsList) {
    benefitsList.classList.remove('hide');
    if (benefitsHeader) benefitsHeader.classList.remove('hide');
    document.querySelectorAll('.benefit-detail').forEach(detail => {
      detail.classList.add('hide');
    });
  }
}

// 福利項目點擊事件
document.querySelectorAll('.benefit-item[data-benefit]').forEach(item => {
  item.addEventListener('click', function() {
    const benefitType = this.getAttribute('data-benefit');
    showBenefitDetail(benefitType);
  });
});

// 返回按鈕點擊事件
document.querySelectorAll('.benefit-back').forEach(backBtn => {
  backBtn.addEventListener('click', function() {
    showBenefitsList();
  });
});

// 活動花絮輪播
function initWelfareCarousel() {
  var track = document.querySelector('.welfare-carousel-track');
  if (!track) return;
  var dots = document.querySelectorAll('.welfare-dot');
  var total = dots.length;
  var currentIndex = 2;

  function goTo(index) {
    currentIndex = (index + total) % total;
    track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  // 觸控滑動
  var touchStartX = 0;
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
    }
  }, { passive: true });

  goTo(currentIndex);
}
initWelfareCarousel();

// Live 區域羽團情報按鈕點擊事件
document.getElementById('btn-badminton-link').addEventListener('click', function(e) {
  const data = {
    event_type: 1,
    event_subtype: 1
  };

  // 根據當前 host 生成 API URL，在子域名前加上 badminton-api-
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  // 如果是 www，則使用 badminton-api.farreaching.com.tw
  var apiHost = 'badminton-api-' + hostname;
  apiHost = apiHost.replace('badminton-api-www.', 'badminton-api.');
  const csrfUrl = protocol + '//' + apiHost + '/sanctum/csrf-cookie';
  const apiUrl = protocol + '//' + apiHost + '/api/v1/event-logs';

  // 先取得 CSRF cookie，再 call event-logs API
  fetch(csrfUrl, {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    },
    credentials: 'include'
  })
  .then(() => {
    // 從 document.cookie 取得 XSRF-TOKEN
    const cookies = document.cookie.split('; ');
    var xsrfToken = '';
    for (var i = 0; i < cookies.length; i++) {
      if (cookies[i].startsWith('XSRF-TOKEN=')) {
        xsrfToken = cookies[i].split('=')[1];
        break;
      }
    }

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken)
      },
      credentials: 'include',
      body: JSON.stringify(data)
    });
  })
  .then(response => response.json())
  .then(result => {
    console.log('event-log 回應:', result);
  })
  .catch(error => {
    console.error('event-log 錯誤:', error);
  });
});



